import { ExperimentItem, Variants_Enum } from './types'

export const experiments: readonly ExperimentItem[] = [
  {
    id: 'kit_second_purchase_price_decrease',
    description: 'Diminuição de preço no kit para segunda compra',
    setInitialValueInSSR: true,
    setInitialValueInHook: false,
    variants: [
      {
        id: 'control',
        value: Variants_Enum.A,
        weight: 50,
      },
      {
        id: 'variant',
        value: Variants_Enum.B,
        weight: 50,
      },
    ],
  },
]
